var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"sidebar-menu"},[_c('li',[_c('router-link',{class:{ a_bg: _vm.active === 'xwgg' },attrs:{"to":{
          path: 'list',
          query: { newstype: 'xwgg' }
        }}},[_c('span',[_vm._v("新闻公告")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:{ a_bg: _vm.active === 'szdt' },attrs:{"to":{
          path: 'list',
          query: { newstype: 'szdt' }
        }}},[_c('span',[_vm._v("市州动态")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:{ a_bg: _vm.active === 'jycy' },attrs:{"to":{
          path: 'list',
          query: { newstype: 'jycy' }
        }}},[_c('span',[_vm._v("就业创业")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0966636","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/list/listCategory.vue
// module id = null
// module chunks = 